import { ModelIcon } from '../ModelIcon';
import { SettingsCard } from './SettingsCard';

export function SettingsModelSection({
  models,
  value,
  onChange,
}: {
  models: Array<{ id: string; publicName: string; iconSvg?: string | null }>;
  value: string;
  onChange: (id: string) => void;
}) {
  const hasMultiple = models.length > 1;

  return (
    <SettingsCard
      title={hasMultiple ? 'مدل‌های پیش‌فرض AI' : 'مدل پیش‌فرض AI'}
      helpKey="default_ai_models"
      description="برای پرامپت‌ها و اجراهای جدید استفاده می‌شود مگر اینکه جای دیگری تغییر دهید."
    >
      <ul className="list-unstyled d-flex flex-wrap gap-3 mb-0">
        {models.map(model => {
          const selected = model.id === value;
          return (
            <li key={model.id}>
              <button
                type="button"
                onClick={() => onChange(model.id)}
                aria-pressed={selected}
                className={`d-flex flex-column align-items-center text-center px-3 pt-3 pb-2 rounded-3 border bg-100 dark__bg-1100 ${
                  selected
                    ? 'border-2 border-primary shadow-sm'
                    : 'border-300'
                }`}
                style={{ width: '10rem', minHeight: '7.25rem' }}
              >
                <ModelIcon
                  svg={model.iconSvg}
                  name={model.publicName}
                  size={36}
                />
                <p
                  className={`mt-2 w-100 text-truncate fs--1 mb-0 ${
                    selected ? 'fw-semibold text-primary' : 'fw-medium text-1000'
                  }`}
                >
                  {model.publicName}
                </p>
                <span
                  className={`badge rounded-pill mt-2 fs--2 ${
                    selected ? 'bg-primary' : 'invisible'
                  }`}
                >
                  پیش‌فرض
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </SettingsCard>
  );
}
